<script setup>
import { FilePDF, CloudDownload } from 'Common/components/elements/icons/Icons'
import { computed, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { JeteyeRoutes } from 'Modules/RouterSetup'

//Store
import { storeToRefs } from 'pinia'
import { useFilterStore } from 'Store/filterStore'
//State
const filterStore = useFilterStore()
const { areFiltersReady, appliedFilterCount } = storeToRefs(filterStore)

const hasFilters = computed(() => {
  return areFiltersReady && appliedFilterCount.value > 0
})
const router = useRouter()
const route = useRoute()
const exportConfirmModal = ref(false)

const exportHandler = () => {
  // if filters open confirmation to proceed
  if (hasFilters.value) {
    exportConfirmModal.value = true
  } else {
    gotoExporter()
  }
}

const gotoExporter = () => {
  exportConfirmModal.value = false
  const routeData = router.resolve({
    name: JeteyeRoutes.SummaryReportExport,
    query: route.query,
  })
  window.open(routeData.href, '_blank')
}
</script>

<template>
  <div id="summary-header-actions" class="-mt-16">
    <div class="flex-1 flex flex-col items-center lg:items-end">
      <div class="flex items-center space-x-4 mt-2">
        <el-button
          disabled
          class="flex items-center bg-blue-600 hover:bg-blue-700 text-gray-100 px-4 py-2 rounded text-sm space-x-2 transition duration-100"
        >
          <CloudDownload />
          <span class="ml-2">Download Data</span>
        </el-button>
        <el-button
          class="disabled flex items-center bg-blue-600 hover:bg-blue-700 text-gray-100 px-4 py-2 rounded text-sm space-x-2 transition duration-100"
          @click="exportHandler"
        >
          <FilePDF />
          <span class="ml-2">Generate Report</span>
        </el-button>

        <el-dialog v-model="exportConfirmModal" title="Export Summary" width="500">
          <span
            >There are currently {{ appliedFilterCount }} filters enabled which affect the data presented in this
            export</span
          >
          <br />
          <span>Do you want to continue?</span>
          <template #footer>
            <div class="dialog-footer">
              <el-button @click="exportConfirmModal = false">Cancel</el-button>
              <el-button type="primary" @click="gotoExporter"> Export </el-button>
            </div>
          </template>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
